import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _80d92402 = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _299b6b92 = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _11edb45a = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _e48dbaf8 = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _a5d341b8 = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _1b5a505c = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _430fbd10 = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _0058b1eb = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _702c2798 = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _39115256 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _1863602e = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _eb97d872 = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _50b90466 = () => interopDefault(import('../pages/sale/index.vue' /* webpackChunkName: "pages/sale/index" */))
const _85f6ebb8 = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _5944099c = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _cf667ef2 = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _0f0e01ae = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _88910338 = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _d9efb512 = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _d7691652 = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _e8f699e4 = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _b4a6bbe4 = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _d906bf7c = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _2565a62a = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _069366f1 = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _b70a5a58 = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _b21317d4 = () => interopDefault(import('../pages/sale/output.vue' /* webpackChunkName: "pages/sale/output" */))
const _26f5e128 = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _01c7106c = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _0c6d5744 = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _da3b6ad6 = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _01b1b3d8 = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _1e2fd971 = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _260ec5a9 = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _7805c9aa = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _272c184e = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _6bdd7fb4 = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _a4e97c6c = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _37da78b4 = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _2a3d6688 = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _3f355488 = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _cf2e9770 = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _3e534912 = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _ebf8a4d4 = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _8ec24fce = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _0ee929e5 = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _796938e2 = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _18d125ae = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _f085151e = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _742b5423 = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _19a18c2c = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _44309eb2 = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _5b0916ed = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _ade55f42 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _5c780cdc = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _0cabe977 = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _1231ec0c = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _4dcb8953 = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _82f7b01c = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _1fadd11d = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _29e16bfe = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _72b00658 = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _16178419 = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _5a97c35e = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _cf2041c8 = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _78d2e427 = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _ab9df57c = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _19ceeb00 = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _b78c4ae8 = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _4dad6b9c = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _53513891 = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _2388793d = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _23e6ae5e = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _be247c02 = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _a347e24e = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _251b4822 = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _80d92402,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _299b6b92,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _11edb45a,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _e48dbaf8,
    name: "calendar"
  }, {
    path: "/customer",
    component: _a5d341b8,
    name: "customer"
  }, {
    path: "/details",
    component: _1b5a505c,
    name: "details"
  }, {
    path: "/goals",
    component: _430fbd10,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _0058b1eb,
    name: "maisoku"
  }, {
    path: "/media",
    component: _702c2798,
    name: "media"
  }, {
    path: "/privacy",
    component: _39115256,
    name: "privacy"
  }, {
    path: "/project",
    component: _1863602e,
    name: "project"
  }, {
    path: "/response",
    component: _eb97d872,
    name: "response"
  }, {
    path: "/sale",
    component: _50b90466,
    name: "sale"
  }, {
    path: "/achievement/output",
    component: _85f6ebb8,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _5944099c,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _cf667ef2,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _0f0e01ae,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _88910338,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _d9efb512,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _d7691652,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _e8f699e4,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _b4a6bbe4,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _d906bf7c,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _2565a62a,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _069366f1,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _b70a5a58,
    name: "response-registration"
  }, {
    path: "/sale/output",
    component: _b21317d4,
    name: "sale-output"
  }, {
    path: "/setting/announcement",
    component: _26f5e128,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _01c7106c,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _0c6d5744,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _da3b6ad6,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _01b1b3d8,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _1e2fd971,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _260ec5a9,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _7805c9aa,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _272c184e,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _6bdd7fb4,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _a4e97c6c,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _37da78b4,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _2a3d6688,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _3f355488,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _cf2e9770,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _3e534912,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _ebf8a4d4,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _8ec24fce,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _0ee929e5,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _796938e2,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _18d125ae,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _f085151e,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _742b5423,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _19a18c2c,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _44309eb2,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _5b0916ed,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _ade55f42,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _5c780cdc,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _0cabe977,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _1231ec0c,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _4dcb8953,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _82f7b01c,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _1fadd11d,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _29e16bfe,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _72b00658,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _16178419,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _5a97c35e,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _cf2041c8,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _78d2e427,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _ab9df57c,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _19ceeb00,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _b78c4ae8,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _4dad6b9c,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _53513891,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _2388793d,
    name: "property-property",
    children: [{
      path: "contact",
      component: _23e6ae5e,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _be247c02,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _a347e24e,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _251b4822,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
